import React from 'react';
import { useViewport } from '../../contexts/ViewportContext';
import { useStatusBarInfo } from '../../hooks/useStatusBarInfo';
import { logger } from '../../utils/logger';

export function ProjectSkeleton() {
  // Get viewport state
  const { isMobile } = useViewport();

  // Get status bar info for mobile adjustments
  const { isNativeApp, statusBarHeight } = useStatusBarInfo();

  // Log status bar info for debugging
  React.useEffect(() => {
    if (isNativeApp && isMobile) {
      logger.capacitor('ProjectSkeleton: Using status bar height', {
        statusBarHeight
      });
    }
  }, [isNativeApp, statusBarHeight, isMobile]);

  // Create an array of 3 skeleton items
  const skeletonItems = [...Array(3)].map((_, index) => (
    <div key={index} className="p-3 transition-colors">
      <div className="flex items-center gap-3">
        {/* Project avatar skeleton */}
        <div className="w-8 h-8 rounded-lg bg-gray-300 flex-shrink-0" />

        {/* Project title and description skeleton */}
        <div className="flex-1 space-y-2">
          <div className="h-4 w-3/4 bg-gray-300 rounded" />
          <div className="h-3 w-1/2 bg-gray-300 rounded" />
        </div>
      </div>
    </div>
  ));

  // For mobile devices, add a header skeleton with status bar padding
  const headerSkeleton = isMobile && (
    <div
      className="sticky top-0 z-50 bg-[var(--sidebar-bg-color)]"
      style={{
        paddingTop: isNativeApp ? `${statusBarHeight}px` : '0',
      }}
    >
      <div className="h-14 px-3 flex items-center">
        <div className="w-40 h-5 bg-gray-300 rounded animate-pulse" />
      </div>
    </div>
  );

  return (
    <div className={isMobile ? "" : "animate-pulse"}>
      {headerSkeleton}
      <div className="animate-pulse">
        {skeletonItems}
      </div>
    </div>
  );
}
